import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Divider } from "@mui/material";
import { MoreHorizOutlined } from "@mui/icons-material";

const JumboDdMenu = ({ icon, menuItems, onClickCallback }) => {
    const [menuEl, setMenuEl] = React.useState(null);
    const openMenu = Boolean(menuEl);

    const handleMenuItemClick = (option) => {
        setMenuEl(null);
        if (typeof onClickCallback === "function")
            onClickCallback(option);
    };

    return (
        <>
            <IconButton
                sx={{
                    color: 'inherit'
                }}
                onClick={(e) => {
                    setMenuEl(e.currentTarget);
                    e.stopPropagation();
                }}

            >
                {icon ? icon : <MoreHorizOutlined />}
            </IconButton>
            <Menu
                open={openMenu}
                anchorEl={menuEl}
                onClose={() => setMenuEl(null)}
            >
                {menuItems.map((option, index) => {
                    if (option.type === 'divider') {
                        return <Divider key={index} />;
                    }

                    if (option.type === 'header') {
                        return (
                            <MenuItem
                                key={index}
                                disabled
                                sx={{
                                    fontStyle: 'italic',
                                    color: 'black',
                                    fontSize: '12px',
                                    lineHeight: 1,
                                    fontFamily: 'NoirPro, Arial',
                                    fontWeight: '400',
                                    opacity: 1,
                                    backgroundColor: 'transparent',
                                    cursor: 'default',

                                }}
                            >
                                {option.title}
                            </MenuItem>
                        );
                    }

                    return (
                        <MenuItem
                            key={index}
                            onClick={(e) => {
                                handleMenuItemClick(option);
                                e.stopPropagation();
                            }}
                        >
                            {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
                            <ListItemText
                                primaryTypographyProps={{ fontSize: '12px', lineHeight: 1 }} // Normal öğe için fontSize 10px
                            >
                                {option.title}
                            </ListItemText>                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

JumboDdMenu.propTypes = {
    icon: PropTypes.node,
    menuItems: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.node,

        })
    ).isRequired,
    onClickCallback: PropTypes.func,
};

export default React.memo(JumboDdMenu);
